// extracted by mini-css-extract-plugin
export default {"countdown":"W1-z","srOnly":"X1-z"};